import React, { useState, useEffect } from 'react';
import { consultarRelatorio, get } from '../../../util/AcessoApi'
import { ConsultaRelatorio } from '../../../components/RelatorioPadrao'
import { InputTipoRelatorio, InputSocio, InputTipoOcorrenciaComFerias, InputTipoDataFiltro, InputTipoRelatorioPersonalizado } from '../../../components/InputsAutoComplete'
import { InputTimePicker, InputDatePicker } from '../../../components/Inputs'
import { BotaoPadrao } from '../../../components/Botoes'
import { Formik, Form } from 'formik'
import ContentLoader from 'react-content-loader'
import Yup, { validaData } from '../../../util/Validacoes';
import { getUsuario } from '../../../util/Configuracoes'
import moment from "moment"
import { InputEstabelecimentoSaude } from '../../../components/InputsAutoCompleteV2';
import { MODULOS_SISTEMA } from '../../../util/Enums';

export default props => {
    const startOfMonth = moment().clone().startOf('month').format('DD/MM/YYYY')
    const endOfMonth = moment().clone().endOf('month').format('DD/MM/YYYY')
    const [filtros, setFiltros] = useState([])
    const [showModalFiltros, setShowModalFiltros] = useState(true)
    const [titulo, setTitulo] = useState('Relatório Ocorrências')
    const [dados, setDados] = useState([])
    const [relatorioSelecionado, setRelatorioSelecionado] = useState(0)
    const [valuesFiltros, setValuesFiltros] = useState({ tipo_relatorio: '', data_inicial: startOfMonth, data_final: endOfMonth, tipo_data_filtragem: { value: 1, label: 'Interposição' } })
    const [relatorioAtual, setRelatorioAtual] = useState({})
    const [carregando, setCarregando] = useState(false)
    const [carregandoFiltros, setCarregandoFiltros] = useState(false)
    const user = getUsuario()

    const tipoRelatorio = [
        { label: 'Ocorrências', value: 1 },
    ]

    const [validacao, setValidacao] = useState(Yup.object({
        data_inicial: Yup.string().nullable().required()
            .test('Data Inicial', 'Data inválida!', function (value) { return validaData(this.parent.data_inicial) }),
        data_final: Yup.string().nullable().required()
            .test('Data Final', 'Data inválida!', function (value) { return validaData(this.parent.data_final) })
    }))

    const relatoriosPorTipo = propsFormik => [
        {
            titulo: 'Relatório Ocorrências',
            tipo: MODULOS_SISTEMA.RELATORIO_DE_OCORRENCIAS,
            url: '/relatorio/relatorioOcorrencia',
            campos: [
                <InputSocio label="Sócio" placeholder="Sócio" name="socio" propsFormik={propsFormik} classeTooltip={'tooltip-input-modal'} multiplo />,
                <InputTipoOcorrenciaComFerias label="Tipo Ocorrência" name="tipo_ocorrencia" propsFormik={propsFormik} classeTooltip={'tooltip-input-modal'} multiplo />,
                <InputEstabelecimentoSaude label="Estabelecimento Saúde" placeholder="Estabelecimento Saúde" name="estabelecimento_saude" propsFormik={propsFormik} classeTooltip={'tooltip-input-modal'} multiplo />,
                <InputTipoDataFiltro multiplo obrigatorio label="Tipo Filtragem de Data" name='tipo_data_filtragem' propsFormik={propsFormik} classeTooltip={'tooltip-input-modal'} isClearable={false} />,
                <InputDatePicker obrigatorio label="Data Inicial" name="data_inicial" type="text" autoFocus
                    setarValor={value => { propsFormik.setFieldValue("data_inicial", value) }} modal classeTooltip={'tooltip-input-modal'} />,
                <InputDatePicker obrigatorio label="Data Final" name="data_final" type="text"
                    setarValor={value => { propsFormik.setFieldValue("data_final", value) }} modal classeTooltip={'tooltip-input-modal'} />,
                <InputTimePicker label="Hora Inicial" mascara="11:11" name="hora_inicial" type="text" placeholder="Hora Inicial" classeTooltip={'tooltip-input-modal'}
                    setarValor={value => { propsFormik.setFieldValue("hora_inicial", value) }} />,
                <InputTimePicker label="Hora Final" mascara="11:11" name="hora_final" type="text" placeholder="Hora Final" classeTooltip={'tooltip-input-modal'}
                    setarValor={value => { propsFormik.setFieldValue("hora_final", value) }} />,
            ],
            classeTr: 'linha-bottom-relatorio',
            colunas: [
                { label: 'Código', name: 'codigo', visivel: false, ordenamento: { tipo: 'numero', ativo: false } },
                { label: 'Sigla', name: 'sigla', visivel: true, ordenamento: { tipo: 'texto', ativo: false } },
                { label: 'Sócio(s)', name: 'socio', visivel: true, ordenamento: { tipo: 'texto', ativo: false } },
                { label: 'Tipo Ocorrência', name: 'tipo_ocorrencia', visivel: true, ordenamento: { tipo: 'texto', ativo: false } },
                { label: 'Data Inicial', name: 'data_inicial', visivel: true, ordenamento: { tipo: 'data', ativo: false } },
                { label: 'Data Final', name: 'data_final', visivel: true, ordenamento: { tipo: 'data', ativo: false } },
                { label: 'Hora Inicial', name: 'hora_inicial', visivel: true, ordenamento: { tipo: 'hora', ativo: false } },
                { label: 'Hora Final', name: 'hora_final', visivel: true, ordenamento: { tipo: 'hora', ativo: false } },
                { label: 'Estabelecimento Saúde', name: 'estabelecimento_saude', visivel: false, ordenamento: { tipo: 'texto', ativo: false } },
                { label: 'Data Registro', name: 'data_registro', visivel: true, ordenamento: { tipo: 'data', ativo: false } },
            ],
            data: [],
            colunasFiltros: [
                { label: 'Sócio(s)', name: 'socio', name_coluna: 'socio' },
                { label: 'Tipo de Ocorrência', name: 'tipo_ocorrencia', name_coluna: 'tipo_ocorrencia' },
                { label: 'Estabelecimento Saúde', name: 'estabelecimento_saude', name_coluna: 'estabelecimento_saude' },
                { label: 'Tipo Filtragem de Data', name: 'tipo_data_filtragem', name_coluna: 'tipo_data_filtragem' },
                { label: 'Data Inicial', name: 'data_inicial', name_coluna: 'data_inicial' },
                { label: 'Data Final', name: 'data_final', name_coluna: 'data_final' },
                { label: 'Hora Inicial', name: 'hora_inicial', name_coluna: 'hora_inicial' },
                { label: 'Hora Final', name: 'hora_final', name_coluna: 'hora_final' },
            ]
        }
    ]

    const submit = (values, propsFormik) => {
        setCarregando(true)
        let novoRelatorio = relatoriosPorTipo(propsFormik).find(x => x.tipo === relatorioSelecionado)

        setShowModalFiltros(false)

        for (let i = Object.keys(values).length; i > 0; i--)
            if (Array.isArray(values[Object.keys(values)[i]]) && values[Object.keys(values)[i]].length === 0 || !values[Object.keys(values)[i]])
                delete values[Object.keys(values)[i]]

        setValuesFiltros(values)
        setRelatorioAtual({ ...novoRelatorio })

        if (values.tipo_relatorio) {
            setFiltros(Object.keys(values).map((x, idx, array) => {
                const valorAtual = values[x]

                return (x !== 'tipo_relatorio'
                    && (typeof valorAtual === 'string' ? valorAtual : (valorAtual && valorAtual.length ? valorAtual.map(y => y.value) && valorAtual.map(y => y.value).length : (valorAtual && valorAtual.value ? valorAtual.value.toString().length : valorAtual))) &&
                {
                    coluna: novoRelatorio.colunasFiltros.find(y => y.name_coluna === x) !== undefined && novoRelatorio.colunasFiltros.find(y => y.name_coluna === x).name_coluna,
                    filtro: novoRelatorio.colunasFiltros.find(y => y.name_coluna === x) !== undefined && novoRelatorio.colunasFiltros.find(y => y.name_coluna === x).label,
                    name: novoRelatorio.colunasFiltros.find(y => y.name_coluna === x) !== undefined && novoRelatorio.colunasFiltros.find(y => y.name_coluna === x).name,
                    value: typeof valorAtual === 'string' ? valorAtual : valorAtual.length ? valorAtual.map(y => y.value) : valorAtual.value,
                    dado: typeof valorAtual === 'string' ? valorAtual : valorAtual.length ? valorAtual.map(y => y.label).toString().split(',').join(', ') : valorAtual.label
                })
            }).filter(x => x && x.value))
        }
        else {
            setRelatorioAtual({})
            setCarregando(false)
            setDados([])
            setFiltros([])
        }
    }

    useEffect(() => {
        let cloneRelatorioAtual = { ...relatorioAtual }

        const newFiltro = [...filtros]

        if (user.tipo === 4)
            newFiltro.push({ coluna: 'usuario', value: user.id }, { coluna: 'tipo', value: user.tipo })

        cloneRelatorioAtual && cloneRelatorioAtual.url &&
            consultarRelatorio(cloneRelatorioAtual.url, array => {
                cloneRelatorioAtual.data = array
                setTitulo(cloneRelatorioAtual.titulo)
                setDados([{ numerarLinha: true, colunas: cloneRelatorioAtual.colunas, data: cloneRelatorioAtual.data, classeTr: cloneRelatorioAtual.classeTr }])
                setCarregando(false)
                setRelatorioAtual(cloneRelatorioAtual)
            }, null, { value: newFiltro })
    }, [filtros])

    const changeTipo = (value) => {
        setRelatorioAtual({})
        setDados([])
        setCarregandoFiltros(true)
        setFiltros([])
        // setRelatorioAtual({})
        // const index = tipoRelatorio.findIndex(x => x.value === value)
        setValuesFiltros({ tipo_relatorio: value, data_inicial: startOfMonth, data_final: endOfMonth, tipo_data_filtragem: { value: 1, label: 'Interposição' } })
        setRelatorioSelecionado(value?.value)
    }

    return (
        <ConsultaRelatorio showModalFiltros={showModalFiltros} setShowModalFiltros={setShowModalFiltros} dados={dados} titulo={titulo} filtros={filtros} setFiltros={setFiltros}
            loading={carregando} limparFiltrosFormik={() => setValuesFiltros({ tipo_relatorio: valuesFiltros.tipo_relatorio })} orientacao={'portrait'}>
            <Formik
                initialValues={valuesFiltros}
                enableReinitialize={true}
                validationSchema={validacao}
                onSubmit={(values, propsFormik) => submit(values, propsFormik)}>
                {propsFormik => (<Form>
                    <div className='row'>
                        <InputTipoRelatorioPersonalizado label="Tipo Relatório" name="tipo_relatorio" placeholder="Tipo Relatório" classeTooltip={'tooltip-input-modal'}
                            propsFormik={propsFormik} modulos={relatoriosPorTipo(propsFormik).map(x => x.tipo)} autoFocus tipoRelatorio={tipoRelatorio} setRelatorioSelecionado={changeTipo} obrigatorio={true} />
                        {relatoriosPorTipo(propsFormik).find(x => x.tipo === relatorioSelecionado) && <div className={carregandoFiltros ? 'd-none' : ''} style={{ width: '100%' }}>
                            {relatoriosPorTipo(propsFormik).find(x => x.tipo === relatorioSelecionado).campos.map(
                                (item, idx, array) => {
                                    if (idx === (array.length - 1)) {
                                        setTimeout(() => {
                                            setCarregandoFiltros(false)
                                        }, 1000)
                                    }
                                    return item
                                }
                            )}
                        </div>}
                        {carregandoFiltros === true ?
                            <ContentLoader
                                speed={2}
                                width='100%'
                                height='400'
                                backgroundColor="#f3f3f3"
                                foregroundColor="#e4e4e4"
                                {...props} >
                                <rect x="12" y="10" rx="3" ry="3" width="170" height="10" />
                                <rect x="12" y="30" rx="3" ry="3" width="355" height="50" />
                                <rect x="12" y="100" rx="3" ry="3" width="170" height="10" />
                                <rect x="12" y="120" rx="3" ry="3" width="355" height="50" />
                                <rect x="12" y="190" rx="3" ry="3" width="170" height="10" />
                                <rect x="12" y="210" rx="3" ry="3" width="355" height="50" />
                                <rect x="12" y="280" rx="3" ry="3" width="170" height="10" />
                                <rect x="12" y="300" rx="3" ry="3" width="355" height="50" />
                            </ContentLoader>
                            : <></>}
                    </div>
                    <div className='direita container-botoes mb-3 group-salvar-novo'>
                        <BotaoPadrao texto='Filtrar' disabled={false} />
                    </div>
                </Form>)}
            </Formik>
        </ConsultaRelatorio >
    )
}